const API = import.meta.env.VITE_API_URL || ''

export function uploaderApiUrl() {
  if (API) return API.replace(/\/$/, '')
  if (window.location.port === '3072') return `${window.location.protocol}//${window.location.hostname}:3071`
  return window.location.origin
}

export async function api(path, options = {}) {
  const response = await fetch(`${API}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      'X-Requested-With': 'fetch',
      ...(options.headers || {}),
    },
  })
  const text = await response.text()
  let body
  try { body = text ? JSON.parse(text) : {} } catch { body = { error: text || `HTTP ${response.status}` } }
  if (!response.ok) {
    const error = new Error(body.message || body.error || 'Something went wrong.')
    error.status = response.status
    error.body = body
    throw error
  }
  return body
}

export function formatBytes(bytes) {
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let amount = Number(bytes || 0)
  let index = 0
  while (amount >= 1024 && index < units.length - 1) { amount /= 1024; index++ }
  return `${amount.toFixed(index ? 1 : 0)} ${units[index]}`
}

export function timeAgo(value) {
  if (!value) return 'Not yet'
  const seconds = Math.round((Date.now() - new Date(value).getTime()) / 1000)
  if (seconds < 60) return 'Just now'
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`
  return `${Math.floor(seconds / 86400)}d ago`
}
